import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';

import { VerifierCredentialStatus, VerifierType } from 'src/api';
import { ModalId } from 'src/constants/modals';
import { useInboxItemParamId } from 'src/hooks/inboxItem';
import { useModal } from 'src/hooks/shared';
import { useVerificationRequestProcessing } from 'src/hooks/verificationRequest';
import { useCurrentUserVerifier } from 'src/hooks/verifier';
import { InboxLayout, LayoutHeaderAction } from 'src/layouts/InboxLayout';
import { VerificationRequestPaymentTryAgainModal } from 'src/modals/verificationRequest';

import { InboxItemContentVerifierStaff } from '../inboxItem/InboxItemContent';

export const InboxVerifierStaff: React.FC = () => {
  const { openModal } = useModal();

  const inboxItemId = useInboxItemParamId();

  const { isSubmitting } = useVerificationRequestProcessing();

  const { verifier } = useCurrentUserVerifier();

  const topAction = React.useMemo((): LayoutHeaderAction => {
    return {
      actionName: 'Create Request',
      icon: <AddIcon />,
      disabled:
        isSubmitting || verifier?.credentialStatus !== VerifierCredentialStatus.Credentialed,
      loading: isSubmitting,
      onAction: () => {
        const modalId =
          verifier?.type === VerifierType.Commercial
            ? ModalId.VerificationRequestCreateByCommercialVerifier
            : ModalId.VerificationRequestCreateByGovernmentVerifier;
        openModal(modalId);
      },
    };
  }, [isSubmitting, verifier?.credentialStatus, verifier?.type, openModal]);

  return (
    <InboxLayout topAction={topAction}>
      <InboxItemContentVerifierStaff inboxItemId={inboxItemId} />

      <VerificationRequestPaymentTryAgainModal />
    </InboxLayout>
  );
};
